import { MutableRefObject, useEffect, useRef, useState} from "react"
import { CourseNavigation } from "./CourseNavigation"
import { ChapterConfig } from "./ChapterConfig"
import { Route, Routes, useLocation, useNavigate } from "react-router"
import { ClassNames } from "../Util/ClassNames"
import { OpenHelpers } from "../Comps/OpenHelpers/OpenHelpers"
import { useAlphabetType, useIsMobile, useProjectStore } from "../Project/ProjectStore"
import { BsFillGearFill, BsList } from "react-icons/bs"
import { Menu, MenuItem, MenuRadioGroup, SubMenu } from "@szhsin/react-menu"
import './Course.scss'
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/zoom.css';
import { ProjectState } from "../Project/ProjectState"
import { useHasOpenHelpers } from "./Helpers/HelperStore"
import { HelperMenu } from "./Helpers/HelperMenu"
import { FlexRowTwo } from "../Layouts/FlexRows"
import { NoteCtrlMenu } from "../Comps/CtrlMenus/NoteCtrlMenu"
import { KeyCtrlMenu } from "../Comps/CtrlMenus/KeyCtrlMenu"
import { CourseState } from "./CourseState"
import { useCourseStore, useVolume } from "./CourseStore"

export function Course(){
    const chapters:MutableRefObject<ChapterConfig[]> = useRef(CourseNavigation.getAllChapters())
    const getChapterElement = (config:ChapterConfig) => {
        const comp:JSX.Element = <div key={config.title}>
                                    
                                    {config.component(config)}
                                </div>
        return comp
    }
    const getChapterRoute = (config:ChapterConfig) => {
        return (<Route path={`${config.path}/*`} key={config.title} element={getChapterElement(config)}/>)
    }
    const someHelpersAreOpen:boolean = useHasOpenHelpers()
    const mobileClassName:string = (useIsMobile()) ? 'mobile' : 'mobile'
    const getHelperFlexClasses = () => {
        const classNames:ClassNames = new ClassNames(['helper-flex'])
        if(!someHelpersAreOpen){ classNames.addClass('closed') }
        return classNames.toString()
    } 
    return( 
            <div>
                <div className="flexy">
                    <div className="chapter-flex">
                        <div className={'chapter-container'}>
                            <Routes>
                                <Route path={'*'} element={getChapterElement(chapters.current[0])}/>
                                {chapters.current.map(getChapterRoute)}
                            </Routes>
                        </div>
                    </div>
                    <div className={getHelperFlexClasses()}>
                        <OpenHelpers/>
                    </div>
                </div>
                <div className={mobileClassName}>
                    <CourseNav/>
                </div>
                <div className={'helper-menu-container'}>
                    <FlexRowTwo columnOneFlex={1} columnTwoFlex={1}>
                        <CourseSettings/><HelperMenu/>
                    </FlexRowTwo>
                </div>
                <NoteCtrlMenu/>
                <KeyCtrlMenu/>
            </div>
    )
}
export function CourseSettings(){
    const alphaType:number = useAlphabetType()
    const alphaTypeSetter:Function = useProjectStore((state:ProjectState)=>{
        return state.setAlphabetType
    })
    const volumeSetter:Function = useCourseStore((state:CourseState)=>{
        return state.setVolume
    })
    const volume:number = useVolume()
    const setVolume = (e:any) => {
        volumeSetter(e.value)
    }
    const setAlphabetType = function(e:any){
        alphaTypeSetter(e.value)
    }
    const loggedInSetter:Function = useProjectStore((state:ProjectState)=>{
        return state.setLoggedIn
    })
    const logOut = function(){
        loggedInSetter(false)
    }
    const boundingBoxRef:MutableRefObject<any> = useRef(null)
    return(
        <div className={'course-settings'}>
            <div  ref={boundingBoxRef} className={'course-settings-bounding-box'}></div>
                <Menu direction={'top'} boundingBoxRef={boundingBoxRef} menuButton={<button type={'button'} className={'setting-button'}>
                    <BsFillGearFill /> Settings</button>} transition>
                      <SubMenu label={'Notation'}>
                        <MenuRadioGroup
                                value={alphaType}
                                onRadioChange={setAlphabetType}>
                                <MenuItem type="radio" value={0}>Sharps</MenuItem>
                                <MenuItem type="radio" value={1}>Flats</MenuItem>
                                <MenuItem type="radio" value={2}>Hawaiian</MenuItem>
                        </MenuRadioGroup>
                    </SubMenu>
                      <SubMenu label={'Volume'}>
                        <MenuRadioGroup
                                value={volume}
                                onRadioChange={setVolume}>
                                <MenuItem type="radio" value={0}>Mute</MenuItem>
                                <MenuItem type="radio" value={.1}>1</MenuItem>
                                <MenuItem type="radio" value={.2}>2</MenuItem>
                                <MenuItem type="radio" value={.3}>3</MenuItem>
                                <MenuItem type="radio" value={.4}>4</MenuItem>
                                <MenuItem type="radio" value={.5}>5</MenuItem>
                                <MenuItem type="radio" value={.6}>6</MenuItem>
                                <MenuItem type="radio" value={.7}>7</MenuItem>
                                <MenuItem type="radio" value={.8}>8</MenuItem>
                                <MenuItem type="radio" value={.9}>9</MenuItem>
                                <MenuItem type="radio" value={1}>10</MenuItem>
                        </MenuRadioGroup>
                    </SubMenu>
                    <MenuItem onClick={logOut}>LogOut</MenuItem>
                </Menu>
        </div>
    )
}
export function CourseNav(){ 
    const currentPath:MutableRefObject<string> = useRef(useLocation().pathname)   
    const navigate = useNavigate()
    const navTo = (path:string) => {
        currentPath.current = path
        navigate(path)
    }
    
    const onSpaceBar = () => {
        const chapters:ChapterConfig[] = CourseNavigation.getAllChapters()
        const currentChapterIndex:number = chapters.findIndex((chapter:ChapterConfig)=>{
            return chapter.path === currentPath.current
        })
        if(currentChapterIndex > -1 && currentChapterIndex < chapters.length - 1){
            const nextChapter:ChapterConfig = chapters[currentChapterIndex + 1]
            navTo(nextChapter.path)
        }
    }
    useEffect(() => {
        const onKeyDown = (event:any) => {
            if (event.code === 'Space') {
                event.preventDefault()
                onSpaceBar()
            }
        }
        window.addEventListener('keydown', onKeyDown)
        return () => {
            window.removeEventListener('keydown', onKeyDown);
            }
        }, []
    )
    const intro:ChapterConfig = CourseNavigation.getIntroChapters()[0]
    return(
            <div className={'course-nav'}>
                <Menu menuButton={<span style={{fontSize:'2em'}}><BsList /></span>}>
                    <MenuItem key={intro.title} onClick={()=>{navTo(intro.path)}}>{intro.title}</MenuItem>
                    <SubMenu label={'Part 1: Diatonic Patterns'}>
                        {CourseNavigation.getDiatonicChapters().map((chapter:ChapterConfig)=>{
                            return <MenuItem key={chapter.title} onClick={()=>{navTo(chapter.path)}}>{chapter.title}</MenuItem>
                        })}
                    </SubMenu>
                    <SubMenu label={'Part 2: Multi-Key Patterns'}>
                        {CourseNavigation.getMultiKeyChapters().map((chapter:ChapterConfig)=>{
                            return <MenuItem key={chapter.title} onClick={()=>{navTo(chapter.path)}}>{chapter.title}</MenuItem>
                        })}
                    </SubMenu>
                    <SubMenu label={'Utilities'}>
                        {CourseNavigation.getUtilChapters().map((chapter:ChapterConfig)=>{
                            return <MenuItem key={chapter.title} onClick={()=>{navTo(chapter.path)}}>{chapter.title}</MenuItem>
                        })}
                    </SubMenu>
                </Menu>
            </div>
    )
}